var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"app"}},[_c('NavBar'),_c('v-content',[_c('v-container',{attrs:{"fluid":"","fill-height":""}},[_c('v-slide-y-transition',{attrs:{"mode":"out-in"}},[_c('router-view')],1)],1)],1),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }